// Publishing
export const RECEIVE_QUEST_CODE = 'RECEIVE_QUEST_CODE';
export const CREATE_PAYMENT = 'CREATE_PAYMENT';
export const RECEIVE_PAYMENT = 'RECEIVE_PAYMENT';
export const NOT_RECEIVE_PAYMENT = 'NOT_RECEIVE_PAYMENT';
export const START_PAYMENT = 'START_PAYMENT';
export const PAYMENT_FAILURE = 'PAYMENT_FAILURE';
export const CHOOSE_BUSINESS_PLAN = 'CHOOSE_BUSINESS_PLAN';
export const PUBLISH_FREE = 'PUBLISH_FREE';
export const OPEN_PUBLISH_POPUP = 'OPEN_PUBLISH_POPUP';
export const START_PUBLISH_PRODUCT = 'START_PUBLISH_PRODUCT';
export const PUBLISH_PRODUCT = 'PUBLISH_PRODUCT';
export const PUBLISH_PRODUCT_SUCCESS = 'PUBLISH_PRODUCT_SUCCESS';
export const PUBLISH_PRODUCT_FAILURE = 'PUBLISH_PRODUCT_FAILURE';
export const RESET_PUBLISH_PRODUCT_ERRORS = 'RESET_PUBLISH_PRODUCT_ERRORS';
export const SEND_PRODUCT_DATA = 'SEND_PRODUCT_DATA';
export const SEND_PRODUCT_DATA_FAILURE = 'SEND_PRODUCT_DATA_FAILURE';

export const SEND_PUBLISH_DATA = 'SEND_PUBLISH_DATA';
export const SEND_PUBLISH_DATA_SUCCESS = 'SEND_PUBLISH_DATA_SUCCESS';
export const SEND_PUBLISH_DATA_FAILURE = 'SEND_PUBLISH_DATA_FAILURE';

export const PATCH_PRODUCT_V1 = 'PATCH_PRODUCT_V1';
export const SEND_LISTED_DATA = 'SEND_LISTED_DATA';
export const SEND_LISTED_DATA_SUCCESS = 'SEND_LISTED_DATA_SUCCESS';
export const SEND_LISTED_IMAGES_DATA_SUCCESS =
  'SEND_LISTED_IMAGES_DATA_SUCCESS';
export const SEND_LISTED_PRICE_DATA_SUCCESS = 'SEND_LISTED_PRICE_DATA_SUCCESS';
export const SEND_LISTED_DATA_FAILURE = 'SEND_LISTED_DATA_FAILURE';
export const POST_LISTED_DATA = 'POST_LISTED_DATA';
export const POST_LISTED_DATA_SUCCESS = 'POST_LISTED_DATA_SUCCESS';
export const POST_LISTED_PRICE_DATA_SUCCESS = 'POST_LISTED_PRICE_DATA_SUCCESS';
export const POST_LISTED_DATA_FAILURE = 'POST_LISTED_DATA_FAILURE';
export const DELETE_LISTED_DATA = 'DELETE_LISTED_DATA';
export const DELETE_MULTIPLE_IMAGES = 'DELETE_MULTIPLE_IMAGES';
export const DELETE_LISTED_DATA_SUCCESS = 'DELETE_LISTED_DATA_SUCCESS';
export const DELETE_IMAGE_SUCCESS = 'DELETE_IMAGE_SUCCESS';
export const DELETE_LISTED_DATA_FAILURE = 'DELETE_LISTED_DATA_FAILURE';
export const SYNC_PRODUCT_IMAGES_ORDER = 'SYNC_PRODUCT_IMAGES_ORDER';
export const RECEIVE_IMAGESTORE_URL = 'RECEIVE_IMAGESTORE_URL';
export const REORDER_PRODUCT_IMAGES = 'REORDER_PRODUCT_IMAGES';
export const REORDER_PRODUCT_IMAGES_SYNC = 'REORDER_PRODUCT_IMAGES_SYNC';

export const REQUEST_PRODUCT = 'REQUEST_PRODUCT';
export const RECEIVE_PRODUCT = 'RECEIVE_PRODUCT';
export const NOT_RECEIVE_PRODUCT = 'NOT_RECEIVE_PRODUCT';

export const SEND_ATTRACTIONS_DATA = 'SEND_ATTRACTIONS_DATA';
export const SEND_ATTRACTIONS_DATA_SUCCESS = 'SEND_ATTRACTIONS_DATA_SUCCESS';
export const SEND_ATTRACTIONS_DATA_FAILURE = 'SEND_ATTRACTIONS_DATA_FAILURE';
export const DELETE_ATTRACTIONS_DATA_SUCCESS =
  'DELETE_ATTRACTIONS_DATA_SUCCESS';

export const SEND_TICKETS_DATA = 'SEND_TICKETS_DATA';
export const SEND_TICKETS_DATA_SUCCESS = 'SEND_TICKETS_DATA_SUCCESS';
export const SEND_TICKETS_DATA_FAILURE = 'SEND_TICKETS_DATA_FAILURE';
export const DELETE_TICKETS_DATA_SUCCESS = 'DELETE_TICKETS_DATA_SUCCESS';
export const SEND_TICKETS_CATEGORIES_DATA = 'SEND_TICKETS_CATEGORIES_DATA';
export const SEND_TICKETS_CATEGORIES_DATA_SUCCESS =
  'SEND_TICKETS_CATEGORIES_DATA_SUCCESS';
export const SEND_TICKETS_CATEGORIES_DATA_FAILURE =
  'SEND_TICKETS_CATEGORIES_DATA_FAILURE';
export const DELETE_TICKETS_CATEGORIES_DATA_SUCCESS =
  'DELETE_TICKETS_CATEGORIES_DATA_SUCCESS';
export const DELETE_TICKET = 'DELETE_TICKET';
export const CONVERT_AUDIO_GUIDES_PRICES = 'CONVERT_AUDIO_GUIDES_PRICES';
export const CONVERT_AUDIO_GUIDES_PRICES_FAILURE =
  'CONVERT_AUDIO_GUIDES_PRICES_FAILURE';
